import { render, staticRenderFns } from "./yuyueAdd.vue?vue&type=template&id=2740cdcd"
import script from "./yuyueAdd.vue?vue&type=script&lang=js"
export * from "./yuyueAdd.vue?vue&type=script&lang=js"
import style0 from "./yuyueAdd.vue?vue&type=style&index=0&id=2740cdcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports